import * as React from "react";
const EnergyDocumentsView = React.lazy(() => import("./EnergyDocumentsViewContainer"));

export { EnergyDocumentsView };
